// extracted by mini-css-extract-plugin
module.exports = {"operations":"styles_operations__3K2Lq"};